import {Component, inject, signal, Signal} from '@angular/core';
import {CustomerNewsletterFormComponent} from '../customer-newsletter-form/customer-newsletter-form.component';
import {CardComponent} from '../card/card.component';
import {MatButton} from '@angular/material/button';
import {MatDialog} from '@angular/material/dialog';
import {CustomerInfoFormModalComponent} from '../customer-info-form-modal/customer-info-form-modal.component';
import {CustomerService, SelectedCustomer} from '../../core/services/customer.service';
import {FlexPosService} from '../../core/services/flex-pos.service';
import {BasicModalService} from '../../core/services/basic-modal.service';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {captureMessage} from '@sentry/angular';

@Component({
  selector: 'app-customer-info',
  standalone: true,
  imports: [
    CustomerNewsletterFormComponent,
    CardComponent,
    MatButton,
    MatProgressSpinner
  ],
  templateUrl: './customer-info.component.html',
  styleUrl: './customer-info.component.scss'
})
export class CustomerInfoComponent {
  private customerService = inject(CustomerService);
  private flexPosService = inject(FlexPosService);
  private dialog = inject(MatDialog);
  private basicModalService = inject(BasicModalService);
  private router = inject(Router);

  customer: Signal<SelectedCustomer> = signal({customer: null, loading: false});
  customerOnJournal: Signal<string | null> = signal(null);

  loadingAddCustomerToJournal = signal(false);
  loadingRemoveCustomerFromJournal = signal(false);
  loadingSendFinishSignupSmsReminder = signal(false);

  constructor() {
    this.customer = this.customerService.selectedCustomer;
    this.customerOnJournal = this.flexPosService.customerOnJournal;
  }

  openCustomerForm() {
    const dialogRef = this.dialog.open(CustomerInfoFormModalComponent, {
      width: '900px',
      maxWidth: '90vw',
    });
  }

  async sendFinishSignupSmsReminder() {
    const vismaId = this.customer().customer?.vismaId;
    if (vismaId) {
      try {
        this.loadingSendFinishSignupSmsReminder.set(true);
        await this.customerService.sendFinishSignupSmsReminder(vismaId);
        this.basicModalService.showSuccessModal('SMS sendt');
      } catch (error) {
        this.basicModalService.showErrorModal('Der skete en fejl');
      }
      this.loadingSendFinishSignupSmsReminder.set(false);
    } else {
      this.basicModalService.showErrorModal('Der skete en fejl. Mangler et vismaId');
    }
  }

  twoSpaceNumber(num?: string|null) {
    if (!num) {
      return '';
    }
    const regex = /\d{2}(?!$)/g;
    return num.replace(regex, '$& ');
  }

  async removeCustomerFromJournal() {
    this.loadingRemoveCustomerFromJournal.set(true);
    await this.flexPosService.clearCustomer();
    this.loadingRemoveCustomerFromJournal.set(false);
  }

  async addCustomerToJournal() {
    const vismaId = this.customer().customer?.vismaId;
    if (vismaId) {
      try {
        this.loadingAddCustomerToJournal.set(true);
        await this.flexPosService.addCustomerToJournal(vismaId);
        this.loadingAddCustomerToJournal.set(false);
      } catch (error) {
        this.basicModalService.showErrorModal('Der skete en fejl');
        this.loadingAddCustomerToJournal.set(false);
      }
    }
    else {
      this.basicModalService.showErrorModal('Der skete en fejl. Mangler et vismaId');
    }
  }

  openOrderHistory() {
    this.router.navigate(['/order-history', this.customer().customer?.vismaId]);
  }

  protected readonly environment = environment;
}
